/**
 * Global Imports
*/

import { Client, ChatUserstate } from 'tmi.js';

/**
 * Local Imports
*/

import { ChatDispatch } from '@system/Chat';
import { Endpoint } from '@system/Network';
import { UserCreate } from '@system/User';

/**
 * Locals
*/

let client: Client;

/**
 * Private Functions
*/

/**
 * @param {string} channel
 * @param {ChatUserstate} state
 * @param {string} contents
 * @param {boolean} self
 *
 * @return {void}
 */
function _handleMessage(
    channel: string,
    state: ChatUserstate,
    contents: string,
    self: boolean): void
{
    return ChatDispatch(UserCreate(state), state, contents, self, channel);
}

/**
 * Public Functions
*/

/**
 * @param {string} username
 * @param {string} password
 * @param {string | Array<string>} channel
 *
 * @return {Promise<Endpoint>}
 */
export function TwitchInit(
    username: string,
    password: string,
    channel: string | Array<string>): Promise<Endpoint>
{
    return new Promise((resolve, reject): void => {
        try {
            client = new Client({
                options: {
                    debug: process.env.APP_DEBUG === 'true',
                },
                identity: { username, password },
                channels: Array.isArray(channel) ? channel : [ channel ],
            });
        } catch (error) {
            return reject(error);
        }

        client.on('message', _handleMessage);
        client.on('connected', (address: string, port: number): void => {
            resolve({ address, port });
        });

        client.connect();
    });
}
